import React from 'react';
import Knob from './Knob';

const PerformanceControlPanel = ({ activeInstrument, engine }) => {
    // Determine active hardware instrument
    // For now, this panel renders CONTROLS for the PASSED activeInstrument
    // ensuring it is hardware type.

    if (!activeInstrument) return null;

    // Check if it's hardware
    const isHardware = activeInstrument.type && activeInstrument.type.startsWith('hardware');
    if (!isHardware) return null;

    const handleKnobChange = (cc, value) => {
        // Send CC via Engine
        // Assuming engine has sendCC(channel, cc, value) or similar
        // Since engine interface might not expose sendCC directly in React context yet,
        // we might need to use a raw Tone.js transport or engine helper.
        // For this task, we assume engine.sendCC exists or we log it.
        if (engine && engine.sendCC) {
            engine.sendCC(activeInstrument.midiChannel, cc, value);
        } else {
            // Fallback for simulation/logging
            console.log(`[MIDI CC] Ch:${activeInstrument.midiChannel} CC:${cc} Val:${value}`);
        }
    };

    return (
        <div className="performance-panel" style={{
            marginTop: '20px',
            padding: '15px',
            border: '1px solid var(--color-gold)',
            borderRadius: '8px',
            background: 'rgba(20, 15, 5, 0.9)'
        }}>
            <h4 style={{ margin: '0 0 10px 0', color: 'var(--color-gold)', textTransform: 'uppercase', letterSpacing: '0.1em', fontSize: '0.9rem' }}>
                {activeInstrument.name} <span style={{fontSize: '0.7em', color: '#888'}}>CH {activeInstrument.midiChannel}</span>
            </h4>

            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                {Array.isArray(activeInstrument.controls) && activeInstrument.controls.map((ctrl) => (
                    <div key={ctrl.cc} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' }}>
                        <Knob
                            label={ctrl.label}
                            value={ctrl.default}
                            min={ctrl.min}
                            max={ctrl.max}
                            onChange={(val) => handleKnobChange(ctrl.cc, val)}
                            size={50}
                            color="var(--color-gold)"
                        />
                        <span style={{ fontSize: '0.6rem', color: '#555', fontFamily: 'monospace' }}>CC {ctrl.cc}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PerformanceControlPanel;
